<template>
  <div>
    
  </div>
</template>

<script>
export default {
  components: {},
  mixins: [],
  data() {
    return {};
  },

  created() {
  },

  mounted() {
  },

  methods: {}
};
</script>





// WEBPACK FOOTER //
// 200.vue?583185fa